import { render } from "./BranchesView.vue?vue&type=template&id=7c0a6e61"
import script from "./BranchesView.vue?vue&type=script&lang=js"
export * from "./BranchesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__